import {gsap} from "../LibrariesImport";

export default class CardsReveal {
    static init() {
        const blocks = document.querySelectorAll(".cards-reveal");
        blocks.forEach((block) => {
           const cards = block.querySelectorAll(".card-reveal");

            cards.forEach((card, index) => {
                gsap.from(card, {
                    opacity: 0,
                    y: `${10 + (index * 2)}vh`,
                    stagger: 1,
                    scrollTrigger: {
                        trigger: card,
                        start: "clamp(top bottom)",
                        end: "clamp(top 75%)",
                        scrub: true,
                        ease: "power2.out"
                    }
                });
            });
        });
    }
}